export default __webpack_public_path__ + "static/media/icon.tourniquets.2d2ec323.svg";